import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import {
    catchError,
    concatMap,
    endWith,
    flatMap,
    map,
    mergeAll,
    mergeMap,
    startWith,
    switchMap,
    take
} from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

// Với từng function, nhận 2 stream là action$ và state$ => dùng pipe() để nối các operator lại. Lấy type của action gửi lên server => gửi api => nhận data => trả về action set của reducer
const postVehicleList = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.NORM_CONFIGURATION.POST_VEHICLE_LIST),
        mergeMap((action) => {
            const api = async () => {
                const vehicleList = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.NORM_CONFIGURATION.POST_VEHICLE_LIST,
                    { ...action.payload }
                )
                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.NORM_CONFIGURATION.SET_VEHICLE_LIST,
                        { data: vehicleList.data.data }
                    )
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getVehicleGroups = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.NORM_CONFIGURATION.GET_VEHICLE_GROUPS),
        mergeMap((action) => {
            const api = async () => {
                const vehicleGroups = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.NORM_CONFIGURATION.GET_VEHICLE_GROUPS
                )
                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.NORM_CONFIGURATION.SET_VEHICLE_GROUPS,
                        { data: vehicleGroups.data.data }
                    )
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getVehicleSettings = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.NORM_CONFIGURATION.GET_VEHICLE_SETTINGS),
        mergeMap((action) => {
            const api = async () => {
                const vehicleSettings = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.NORM_CONFIGURATION.GET_VEHICLE_SETTINGS,
                    { ...action.payload }
                )
                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.NORM_CONFIGURATION
                            .SET_VEHICLE_SETTINGS,
                        { data: vehicleSettings.data.data }
                    )
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const postSaveAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.NORM_CONFIGURATION.POST_SAVE_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const saveAction = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.NORM_CONFIGURATION.POST_SAVE_ACTION,
                    { ...action.payload }
                )
                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.NORM_CONFIGURATION.SET_SAVE_ACTION,
                        {
                            data: {
                                status: saveAction.data.status,
                                message: saveAction.data.mess
                            }
                        }
                    )
                )

                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.SYSTEM.STATUS,
                        saveAction.data.status
                    )
                )

                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getDeleteAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.NORM_CONFIGURATION.GET_DELETE_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const deleteAction = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.NORM_CONFIGURATION.GET_DELETE_ACTION,
                    { ...action.payload }
                )
                let arrayAction = []
                deleteAction.data.status
                    ? arrayAction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.STATUS,
                              deleteAction.data.status
                          )
                      )
                    : arrayAction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                              deleteAction.data.mess
                          )
                      )

                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.NORM_CONFIGURATION.SET_DELETE_ACTION, {
                            data: {
                                status: deleteAction.data.status,
                            }
                        }
                    )
                )

                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

export default {
    postVehicleList,
    getVehicleGroups,
    getVehicleSettings,
    postSaveAction,
    getDeleteAction
}
